import {
    Control,
    FieldErrors,
    UseFormClearErrors,
    UseFormGetValues,
    UseFormRegister,
    UseFormSetError,
    UseFormSetValue,
    UseFormTrigger,
} from 'react-hook-form';
import { CompanyProfile, EmploymentType, WorkExperience } from '../../../gql-operations/gql-generated';

export interface WorkExperienceFormType {
    title: string;
    employmentType: EmploymentType;
    company: CompanyProfile;
    startDate: Date;
    endDate?: Date;
    startMonth: string;
    endMonth?: string;
    startYear: string;
    endYear?: string;
    currentlyWorking: boolean;
    description: string;
    skills: string[];
    industry?: string;
}

export type WorkExperienceFormDefaultValuesType =
    | {
          title?: string;
          employmentType?: EmploymentType;
          company?: Partial<CompanyProfile>;
          startDate?: Date;
          endDate?: Date;
          startMonth?: string;
          endMonth?: string;
          startYear?: string;
          endYear?: string;
          currentlyWorking?: boolean;
          description?: string;
          skills?: (string | undefined)[];
          industry?: string;
      }
    | undefined;

export interface FieldComponentProps {
    control: Control<WorkExperienceFormType>;
    errors?: FieldErrors<WorkExperienceFormType>;
}

export interface SimpleFieldComponentProps {
    register: UseFormRegister<WorkExperienceFormType>;
    defaultValues?: WorkExperienceFormDefaultValuesType;
}

export enum WorkExperienceViewStates {
    AddEdit,
    Empty,
    List,
}

export interface CurrentViewState {
    viewState: WorkExperienceViewStates;
    experienceId?: string;
    isDirty?: boolean;
}

export interface TemporaryWorkExperience extends WorkExperience {
    isNew?: boolean;
}

export interface DatesFieldProps extends FieldComponentProps {
    currentlyWorking: boolean;
    getValues: UseFormGetValues<WorkExperienceFormType>;
    setError: UseFormSetError<WorkExperienceFormType>;
    clearErrors: UseFormClearErrors<WorkExperienceFormType>;
    setValue: UseFormSetValue<WorkExperienceFormType>;
    trigger: UseFormTrigger<WorkExperienceFormType>;
}

export interface WorkExperienceUpsertRequest {
    workExperiences: {
        title: string;
        employmentType: EmploymentType;
        company: CompanyProfile;
        startDate?: number | null;
        endDate?: number | null;
        skills?: string[];
        description?: string | null;
    }[];
}

interface LinkedInCompany {
    id?: string;
    name: string;
    industry?: string | null;
    logoUrl?: string;
}

export interface WorkExperienceFromLinkedIn
    extends Omit<WorkExperience, 'company' | 'startDate' | 'endDate' | 'currentJob' | 'employmentType' | 'id'> {
    company: LinkedInCompany;
    startDate: string;
    endDate?: string;
    industry: string | null;
}

export interface LinkedInData {
    workExperiences?: WorkExperienceFromLinkedIn[] | null;
    profileUrl?: string;
}

export interface LinkedInImportTriggerResponse {
    channelName: string;
}
